<template>
  <div>
    <header-sales></header-sales>
    <!--pc view-->
    <div v-if="!mobileView">
      <div id= "subheader"> </div> 
      <div id= "main-container" style="top: 50vh; height: 90vh;"> 
  
        <div class="fv lc" style="width: 700px; height: 10vh">
          <span id="label">Presupuesto</span>
        </div> 
  
        <div id= "container" style="height: 82vh">
          <div id="list-container">
            <item-pedido id="list-prod" v-if="show" v-for="item in items" :item='item' @eliminarItem="btnEliminarItem"  ></item-pedido>
          </div>
          <div class="fv rc" style="width: 100%; margin-top: 10px">
              <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Subtotal: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{subtotal | formatMoney}} </div>
              </div>
              <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Descuentos: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{descuentos | formatMoney}} </div>
              </div>
              <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Impuestos: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{impuestos | formatMoney}} </div>
              </div>
              <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 14px; color:#5D6770"> Total: </div>
                  <div class="fh rc" style="width: 150px; font-size: 14px; color:#5D6770"> ${{subtotal - descuentos + impuestos | formatMoney}} </div>
              </div>
          </div>
          <div id="btnContainer" style="margin-top: 5px">
            <input id="btnEliminar" @click="btnEliminar" type="submit" value="ELIMINAR">
            <!-- <input id="btnGuardar" @click="btnGuardar" type="submit" value="GUARDAR"> -->
            <input id="btnAgregar" @click="btnAgregar" type="submit" value="AGREGAR">
            <input id="btnEnviar" @click="btnEnviar" type="submit" value="ENVIAR">
          </div> 
        </div> 


      </div> 
    </div> 

    <!--mobile view-->
    <div v-if="mobileView">
      <div class="fv ct" style="width: 100vw; height:100vh; margin-top: 40px">
          <div class="fh cc" style="width: 100%; height:4%; background:#44C7F4; color:white; font: size 12px;">Carrito de Compras</div>
          <div class="fh cc" style="width: 100%; height:5%; background:#eeeeee;">
            <div class="fh cc" style="width: 33%; height:100%; font-size: 14px; color: #5C666F">Subtotal: ${{subtotal | formatMoney}}</div>
            <div class="fh cc" style="width: 33%; height:100%; font-size: 14px; color: #5C666F">Descuentos: -${{descuentos | formatMoney}}</div>
            <div class="fh cc" style="width: 33%; height:100%; font-size: 14px; color: #5C666F">Impuestos: ${{impuestos | formatMoney}}</div>
          </div>
          <div class="fh cc" style="width: 100%; height:5%; background:#eeeeee;">
            <div class="fh cc" style="width: 100%; height:5%;font-size: 18px; font-weight: 500; color: #5C666F" >Total: ${{subtotal - descuentos + impuestos| formatMoney}}</div>
          </div>
          <div id="list-container" style="height: 55%">
            <item-pedido id="list-prod" v-if="show" v-for="item in items" :item='item' @eliminarItem="btnEliminarItem"> </item-pedido>
          </div>
          <div class="fh cc" style="margin-top: 20px">
            <div class="btnMobile" style="background: white;color:#ff0000; border:none" @click="btnEliminar">ELIMINAR</div>
            <!-- <div class="btnMobile" style="background: white;color: #4969B2; border-style: solid; border-width: 1px; border-color: #4969B2;" @click="btnGuardar">GUARDAR</div> -->
            <div class="btnMobile" @click="btnAgregar">AGREGAR</div>
            <div class="btnMobile" @click="btnEnviar">ENVIAR</div>
          </div> 
      </div>
    </div>


 <!-- ....................................... POPUP ........................................ -->
   <!--pc view-->
   <div v-if="!mobileView">
     <transition name="fadePro">
      <div v-show='showPopup' :showPopup='showPopup'>
        <div id='back-popup'>
        </div>
        <div id='popup-envio-pedido'>
          <div id='popup-btnClose-container'>
            <img id='btnClose' @click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
          </div>
          <p id='popup-titulo' style="margin-bottom: 20px">Enviar Presupuesto</p>
          <div class="labels-forms" v-show="showCondicionVenta">Condición de venta</div>
          <select class="wc" v-model="condicionVenta" v-show="showCondicionVenta">
            <option v-for="option in condicionesVenta" v-bind:value="option">{{ option.Nombre }}</option>
          </select>
          <div class="labels-forms" v-show="showCalendar">Fecha de despacho</div>
          <datepicker wrapper-class="wc" input-class="datepicker-ic" :disabledDates="disabledDates" v-model="calendario" v-show="showCalendar"> </datepicker>
          <div class="labels-forms" v-show="showSucursal">Sucursal de entrega</div>
          <select class="wc" v-model="sucursal" v-show="showSucursal">
            <option v-for="option in sucursales" v-bind:value="option">{{ option.Nombre }}</option>
          </select>
          <div class="labels-forms" v-show="showEmail">Email para envíar el Pedido en PDF</div>
          <input style="text-align: left;  padding-left: 10px; margin-left:30px;margin-bottom: 20px; width:336px;height:30px;font-size: 14px; font-weight: 100;  border-radius:5px;border-style:solid;" type="email" v-model='email' v-show="showEmail">
          <div class="labels-forms">Observaciones</div>
          <textarea id='obs' v-model="observaciones"> </textarea>
          <div id="btnContainerPopup">
            <button  @click="btnCerrarPopup" id="btnclose">CANCELAR</button>
            <button  @click="btnEnviarPopup" id="btnsend">ENVIAR</button>
          </div>
        </div>
      </div>
     </transition>
   </div>

   <!--mobile view-->
   <div v-if="mobileView">
     <transition name="fadePro">
      <div class="fv lt"   v-show='showPopup' :showPopup='showPopup'>
        <div id='back-popup'>
        </div>
        <div id='popup-envio-pedido' style="width: 90vw">
          <div class="fh rb" style="width: 100%; height: 30px;">
            <img id='btnClose' @click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px; margin-right: 15px">
          </div>
          <div class="fh cc" style="height: 60px; font-size: 18px; color: #5C666F;">Enviar Pedido</div>   
          <div class="fh lc" style="margin-left: 5%; height: 10%; font-size: 12px; color: #5C666F;" v-show="showCondicionVenta">Condición de venta</div>   
          <select class="wc-mobile" v-model="condicionVenta" v-show="showCondicionVenta">
            <option v-for="option in condicionesVenta" v-bind:value="option">{{ option.Nombre }}</option>
          </select>
          <div class="fh lc" style="margin-left: 5%; height: 10%; font-size: 12px; color: #5C666F;" v-show="showCalendar">Fecha de despacho</div>
          <datepicker wrapper-class="wc-mobile" input-class="datepicker-ic-mobile" style="padding-left: 8px"  :disabledDates="disabledDates" v-model="calendario" v-show="showCalendar"> </datepicker>
          <div class="fh lc" style="margin-left: 5%; height: 10%; font-size: 12px; color: #5C666F;" v-show="showSucursal">Sucursal de entrega</div>   
          <select class="wc-mobile" v-model="sucursal" v-show="showSucursal">
            <option v-for="option in sucursales" v-bind:value="option">{{ option.Nombre }}</option>
          </select>
          <div class="fh lc" style="margin-left: 5%; height: 10%; font-size: 12px; color: #5C666F;" v-show="showEmail">Email para envíar el Pedido en PDF</div>
          <input style="text-align: left;  padding-left: 10px; margin-left: 5%;margin-bottom: 10px; width:88%; height:30px;font-size: 14px;border-radius:5px;border-style:solid; color: black" type="email" v-model='email' v-show="showEmail">
          <div class="fh lc" style="margin-left: 5%; height: 10%; font-size: 12px; color: #5C666F;">Observaciones</div>   
          <textarea style="resize: none; width: 85%; margin-left: 5%; padding: 10px; border-radius: 5px; height:90px; border-style: solid; border-width: 1px;border-color: #dddddd; font-family:'Rubik', sans-serif;"  v-model="observaciones"> </textarea>
          <div id="btnContainerPopup">
            <button  @click="btnCerrarPopup" id="btnclose">CANCELAR</button>
            <button  @click="btnEnviarPopup" id="btnsend">ENVIAR</button>
          </div>
        </div>
      </div>
     </transition>
   </div>
  </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemPedido from '@components/views/presupuestos/ItemPresupuesto.vue';
  import Vue from 'vue'
  import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
  import * as lang from "vuejs-datepicker/src/locale";


  export default {
    name: 'Pedido',
    components:{
     'header-sales': HeaderSales,
     'item-pedido': ItemPedido,
      Datepicker
    },

    data() {
       return {
         showPopup:false,
         productos:[],
         pedido:null,
         pedidos: [],
         observaciones:'',
         grupoProductos:  [],
         descuentosAplicados: [],
         descuentosAC: [],
         descuentosPedido: [],           //--> AGREGAR   
         descuentosSend: [],
         sucursal: "",
         condicionVenta:"",  
         numPedidoEdit:false,
         idItemEliminar:-1,
         calendario:"",
         errorMsg:"", 
         show:true,
         disabledDates: 
         {
           to: null,
           days: [],
           dates:[]
         },
         mobileView:false,
         email:"",
         prodDes: [],
         arrayDescuentos: [],
         arrayDescuentosProducto: [],
         arrayDescuentosPedido: [],
         totalAC: 0,
         totalImpuesto: 0,  
         carritoDes: [],
         comboPrecioSinImp: 0,
         comboImp: 0,
         descAsocs: [],
         descAsocsPorProd: [],
         totalDescAsocs: 0,
         descAC: 0,
         descuentosV2Pedido: [],
         descAsocAgrup: [] 
       }
    },


    computed: {

      showEmail() {
         return this.$store.state.user.usuario.PermiteEnvioPdf 
      },

      showSucursal() {
         if ((this.$store.state.user.cliente.Sucursales != null)&&(this.$store.state.user.cliente.Sucursales.length > 1))
         {
            return true;  
         }
         else
         {
           if ((this.$store.state.user.cliente.Sucursales != null)&&(this.$store.state.user.cliente.Sucursales.length == 1))
           {
              this.sucursal = this.$store.state.user.cliente.Sucursales[0] 
              return false;  
           }
           else
           {
              return false;  
           }
         }
      },

      showCondicionVenta() {
         if (this.$store.state.user.usuario.EsEmpleado)
         {
            return true;  
         }
         else
         {
            return false;  
         }
      },

      showCalendar() {
         if (this.$store.state.user.usuario.IngresaFechaEntrega)
         {
            return true;  
         }
         else
         {
            return false;  
         }
      },

      condicionesVenta() {
         return this.$store.state.user.cliente.CondicionesVenta;
      },

      sucursales() {
         var sucursales = [] 
         if (this.$store.state.user.usuario.PermiteRetiroDeposito) {
           var retiroPorDeposito = {
               Direccion:"",
               Linea: -1,
               Localidad:"",
               Nombre:"Retira por depósito"
           }
           sucursales.push(retiroPorDeposito)
         }
         return sucursales.concat(this.$store.state.user.cliente.Sucursales);
      },

      numPedido() {
        if ((this.$store.state.pedido.pedidosHome != null) && (this.$store.state.pedido.pedidosHome.length > 0))
        {
          return this.$store.state.pedido.pedidosHome[0].Id
        }
        else
        {
          return 0
        }
      },

    items() {
        var carrito = [...this.$store.state.pedido.carrito.map(obj => ({ ...obj }))];
        var descuentos = [...this.$store.state.pedido.descuentos.map(obj => ({ ...obj }))];
        this.carritoDes = []
        var precioConDesc = 0 
        var impuesto = 0
        this.arrayDescuentos = [] 
        this.arrayDescuentosPedido = [] 
        this.arrayDescuentosProducto = [] 
        this.totalAC = 0 
        this.totalImpuesto = 0 
        this.comboPrecioSinImp = 0
        this.comboImp = 0
        this.descAsocs = []
        var precioDescPorNivel = []

        //------------------------------------------
        descuentos.sort((a, b) => {
            if (a.Nivel === b.Nivel) {
                return a.Secuencia - b.Secuencia;
            }
            return a.Nivel - b.Nivel;
        });
        //------------------------------------------

        // console.log('<carrito>') 
        // console.log(carrito) 

        carrito.forEach((c)=> { 
            var totalDesc = 0
            descuentos.forEach((d)=> { 

                // afecta a productos 
                if (d.AfectaA == 1) {
                    if (d.Productos.some(prod => prod.Id === c.id)) {
                        var cantTotal = this.getTotalProdsPorDescProd(d.Productos)
                        var descNivel = 0
                        var nivel = d.Nivel
                        while (nivel > 1) {
                            descNivel = descNivel + this.getDescuentosPorNivel(c.id,nivel)
                            nivel--
                        }
                        var subtotal = this.getTotalImporte(d)
                        var escala = this.getPorcentaje(d,cantTotal,subtotal)
                        var desc = {
                            Id: d.Id,
                            IdProd: c.id,
                            Titulo: d.Titulo,
                            Nivel: d.Nivel,
                            Secuencia: d.Secuencia,
                            Excluyente: d.Excluyente,
                            Cantidad: c.cantidad,
                            Porc: escala.porc,
                            Tope: escala.tope,
                            Desc: ((c.precio * c.cantidad) - descNivel) * escala.porc
                        }   
                        this.descAsocs.push(desc)  
                    }
                }

                // afecta a categoriasN1 
                if (d.AfectaA == 2) {
                    if (d.CategoriaN1.some(cat => cat.Id === c.idCategoria)) {
                        var cantTotal = this.getTotalProdsPorCat(d.CategoriaN1)
                        var descNivel = 0
                        var nivel = d.Nivel
                        while (nivel > 1) {
                            descNivel = descNivel + this.getDescuentosPorNivel(c.id,nivel)
                            nivel--
                        }
                        var subtotal = this.getTotalImporte(d)
                        var escala = this.getPorcentaje(d,cantTotal,subtotal)
                        var desc = {
                            Id: d.Id,
                            IdProd: c.id,
                            Titulo: d.Titulo,
                            Nivel: d.Nivel,
                            Secuencia: d.Secuencia,
                            Excluyente: d.Excluyente,
                            Porc: escala.porc,
                            Tope: escala.tope,
                            Desc: ((c.precio * c.cantidad) - descNivel) * escala.porc
                        }   
                        this.descAsocs.push(desc)  
                    }
                }

                // afecta a categoriasN2 
                if (d.AfectaA == 3) {
                    if (d.CategoriaN2.some(cat => cat.Id === c.idSubcategoria)) {
                        var cantTotal = this.getTotalProdsPorSubcat(d.CategoriaN2)
                        var descNivel = 0
                        var nivel = d.Nivel
                        while (nivel > 1) {
                            descNivel = descNivel + this.getDescuentosPorNivel(c.id,nivel)
                            nivel--
                        }
                        var subtotal = this.getTotalImporte(d)
                        var escala = this.getPorcentaje(d,cantTotal,subtotal)
                        var desc = {
                            Id: d.Id,
                            IdProd: c.id,
                            Titulo: d.Titulo,
                            Nivel: d.Nivel,
                            Secuencia: d.Secuencia,
                            Excluyente: d.Excluyente,
                            Porc: escala.porc,
                            Tope: escala.tope,
                            Desc: ((c.precio * c.cantidad) - descNivel) * escala.porc
                        }   
                        this.descAsocs.push(desc)  
                    }
                }
            });

            if (c.promocionId > 0) {
                this.comboPrecioSinImp = this.comboPrecioSinImp + (this.promocionSinImpuestoPromo(c.promocionId) * c.cantidad)
                this.comboImp = this.comboImp + (this.promocionImpuesto(c.promocionId) * c.cantidad)
            }

            var cd = {
                'ImagenUrl' : c.ImagenUrl,
                'cantidad' : c.cantidad,
                'descripcion' :c.descripcion,
                'descuento': c.descuento,
                'esPromo' : c.esPromo,
                'id' : c.id,
                'idCategoria' : c.idCategoria,
                'idSubcategoria' : c.idSubcategoria,
                'permiteDecimales' : c.permiteDecimales,
                'peso' : c.peso,
                'porcentajeDescuento' : c.porcentajeDescuento,
                'porcentajeImpuesto' : c.porcentajeImpuesto,
                'precio' : c.precio,
                'precioLista' : c.precioLista,
                'producto' : c.producto,
                'promocionId' : c.promocionId,
                'tipoOblea' : c.tipoOblea,
                'unidadesMinimaVenta' : c.unidadesMinimaVenta,
                'unidadesPorPedido' : c.unidadesPorPedido,
                'precioConDesc' : precioConDesc,
                'impuesto' : impuesto,
                'arrayDescuentosProducto' : this.arrayDescuentosProducto
            }
            this.carritoDes.push(cd)
        });
        var aux = this.carritoDes.concat(this.arrayDescuentos);    

        //----------------------------- Ordenamiento de descuentos por nivel y secuencia---------------------------------
        this.descAsocs.sort((a, b) => {
            if (a.Nivel === b.Nivel) {
                return a.Secuencia - b.Secuencia;
            }
            return a.Nivel - b.Nivel;
        });
        //----------------------------------------------------------------------------------------------------------------


        //----------------------------------------- Descuentos excluyentes -----------------------------------------------
        // console.log('<this.descAsocs>') 
        // console.log(this.descAsocs) 

        var auxDescAsocs = []
        var excluyente = false
        var nivel = 0
        var idDesc = 0
        this.descAsocs.forEach((d)=> { 
            if (!excluyente) {
                auxDescAsocs.push(d)
            }            
            else if (idDesc == d.Id) {
                auxDescAsocs.push(d)
            }
            if ((excluyente) && (d.Nivel > nivel)) {
                auxDescAsocs.push(d)
                excluyente = false
                nivel = d.Nivel
                idDesc = d.Id
            }
            if (d.Excluyente) {
                excluyente = true
                nivel = d.Nivel
                idDesc = d.Id
            }
        })

        this.descAsocs = auxDescAsocs 
        // console.log('<this.descAsocs2>') 
        // console.log(this.descAsocs) 
        //----------------------------------------------------------------------------------------------------------------


        //--------------------------------------- Check topes descuentos ANTES agrupar ---------------------------------
        this.descAsocs.forEach((d)=> { 
            if (Number(d.Tope) > 0) {
                if (Number(d.Desc) > Number(d.Tope)) {
                    d.Desc = d.Tope
                }
            }
        })
        // console.log('<this.descAsocTOPE>') 
        // console.log(this.descAsocs) 
        //--------------------------------------------------------------------------------------------------------------


        //--------------------------------------- Agrupacion de descuentos ----------------------------------------------
        this.descAsocAgrup = [] 
        this.descAsocs.forEach((d)=> { 
            var index = -1
            if (this.descAsocAgrup.length > 0) {
                index = this.descAsocAgrup.findIndex(da => da.Id === d.Id);
            }
            if (index == -1) {
                var daa =  {
                    Id: d.Id,
                    IdProd: d.IdProd,
                    Nivel: d.Nivel,
                    Titulo: d.Titulo,
                    Porc: d.Porc*100,
                    Tope: d.Tope,
                    Desc: Number(d.Desc)
                }
                this.descAsocAgrup.push(daa)
            }
            else {
                var daa = this.descAsocAgrup[index]
                daa.Desc = Number(daa.Desc) +  Number(d.Desc)
                this.descAsocAgrup[index] = daa
            }
        })

        // console.log('<this.descAsocAgrup>') 
        // console.log(this.descAsocAgrup) 

        //---------------------------------------------------------------------------------------------------------------


        //--------------------------------------- Muestra grupos descuentos por pantalla---------------------------------
        this.totalDescAsocs = 0  
        this.descAsocAgrup.forEach((d)=> { 
            if (d.Desc > 0) {
                var des = {
                    'Id': 0,
                    'Nombre': '',
                    'Total': 0,
                    'precio': d.Desc,
                    'producto': d.Titulo + ' '+ d.Porc + '%',
                    'tipoOblea': 2
                }
                aux.push(des)
            } 
            this.totalDescAsocs = Number(this.totalDescAsocs) + Number(d.Desc)
        })
        //---------------------------------------------------------------------------------------------------------------

        // console.log('<this.descAsocs>') 
        // console.log(this.descAsocs) 

        //------------------------------------------------ Calculos Impuestos -------------------------------------------
        var totalDescPorProd = []         
        this.descAsocs.forEach((d)=> { 
            var index = -1
            var prod = carrito.find( item => item.id === d.IdProd)
            if (totalDescPorProd.length > 0) {
                index = totalDescPorProd.findIndex(da => da.IdProd === d.IdProd);
            }
            if (index == -1) {
                var daa =  {
                    IdProd: d.IdProd,
                    Imp: prod.porcentajeImpuesto,
                    Cantidad: prod.cantidad,
                    Precio: prod.precio,
                    Desc: Number(d.Desc)
                }
                totalDescPorProd.push(daa)
            }
            else {
                var daa = totalDescPorProd[index]
                daa.Desc = Number(daa.Desc) +  Number(d.Desc)
                totalDescPorProd[index] = daa
            }
        })
        // console.log('<totalDescPorProd>') 
        // console.log(totalDescPorProd) 

        
        this.totalImpuesto = 0
        totalDescPorProd.forEach((d)=> { 
            this.descAC = 0
            if (this.$store.state.user.cliente.DescuentoHabilitado) {
                this.descAC = this.$store.state.user.cliente.DescuentoPorcentaje/100
            }
            var subtot1 = Number(d.Cantidad) * Number(d.Precio)
            // console.log('<subtot1>') 
            // console.log(subtot1) 
   
            var desc1 = subtot1 * Number(this.descAC)
            // console.log('<this.descAC>') 
            // console.log(this.descAC) 
            // console.log('<desc1>') 
            // console.log(desc1) 
   
            var subtot2 = subtot1 - Number(d.Desc) - desc1
            // console.log('<d.Desc>') 
            // console.log(d.Desc) 
            // console.log('<subtot2>') 
            // console.log(subtot2) 

            var impProd = d.Imp/100
            // console.log('<d.Imp>') 
            // console.log(d.Imp) 
            // console.log('<impProd>') 
            // console.log(impProd) 
   
            var subtot3 = subtot2 * impProd 
            // console.log('<subtot3>') 
            // console.log(subtot3) 
   
            this.totalImpuesto = this.totalImpuesto + Number(subtot3)
        })
        //------------------------------------------------------------------------------------------------------------


        //-------------------------------------------- Muestra AC por pantalla---------------------------------------- 
        if (this.descAC > 0) {
            var ac = {
                'Id': 0,
                'Nombre': '',
                'Total': 0,
                'precio': this.subtotal * this.descAC,
                'producto': 'Acuerdo Comercial Descuento '+this.$store.state.user.cliente.DescuentoPorcentaje+'%',
                'tipoOblea': 2
            }
            aux.push(ac)
        }
        //----------------------------------------------------------------------------------------------------------

        return aux  
    },  

    subtotal () {
        var st= 0.0; 
        this.$store.state.pedido.carrito.forEach(function(element) {
            if (element.id > 0) {
                st = st + ((element.precio - (element.precio*(element.porcentajeDescuento/100))) * element.cantidad)
            }
        });     
        st = st + this.comboPrecioSinImp 
        return st;
    },

    descuentos () {
        return this.totalDescAsocs + (this.subtotal * this.descAC)
    },

    impuestos() {
        return this.totalImpuesto + this.comboImp
    }

  },


  methods: {

    getDescuentosPorNivel(idProd,nivel) {
        var desc = 0
        if (nivel > 1) {
            this.descAsocs.forEach((d) => { 
                if ((d.IdProd == idProd) && (d.Nivel == (nivel-1))) {
                    desc = desc + d.Desc   
                }
            })
        }  
        return desc
    },


    /**********************************************************************/
    getTotalImporte(descuento) {
        var total = 0.0
        //var carrito = this.$store.state.pedido.carrito
        var carrito = [...this.$store.state.pedido.carrito.map(obj => ({ ...obj }))];
        carrito.forEach((c) => { 
            // afecta a productos 
            if (descuento.AfectaA == 1) {
                if (descuento.Productos.some(p => p.Id === c.id)) {
                    total = total + (c.precio * c.cantidad)
                }
            }
            // afecta a categorias 
            if (descuento.AfectaA == 2) {
                if (descuento.CategoriaN1.some(cat => cat.Id === c.idCategoria)) {
                    total = total + (c.precio * c.cantidad)
                }
            }
            // afecta a subcategorias 
            if (descuento.AfectaA == 3) {
                if (descuento.CategoriaN2.some(sub => sub.Id === c.idSubcategoria)) {
                    total = total + (c.precio * c.cantidad)
                }
            }
        })
        return total
    }, 
    /**********************************************************************/


    getTotalProdsPorDescProd(productos) {
        var carrito = [...this.$store.state.pedido.carrito.map(obj => ({ ...obj }))];
        var total = 0
        carrito.forEach((c) => { 
            productos.forEach((prod) => { 
                if (prod.Id == c.id) {
                    total =  Number(total) +  Number(c.cantidad)
                }
            })
        })
        return total 
    },


    getTotalProdsPorCat(categorias) {
        var carrito = [...this.$store.state.pedido.carrito.map(obj => ({ ...obj }))];
        var total = 0
        carrito.forEach((c) => { 
            categorias.forEach((cat) => { 
                if (cat.Id == c.idCategoria) {
                    total =  Number(total) +  Number(c.cantidad)
                }
            })
        })
        return total 
    },

    getTotalProdsPorSubcat(subcategorias) {
        var carrito = [...this.$store.state.pedido.carrito.map(obj => ({ ...obj }))];
        var total = 0
        carrito.forEach((c) => { 
            subcategorias.forEach((subcat) => { 
                if (subcat.Id == c.idSubcategoria) {
                    total =  Number(total) +  Number(c.cantidad)
                }
            })
        })
        return total 
    },


    getPorcentaje(d,cantidad,importe) {
        var output = {
            porc:0,
            tope:0 
        }
        d.Escalas.forEach((e) => { 
            // importe            
            if (d.Tipo == 1) { 
                if (Number(e.ValorDesde) <= Number(importe)) {
                    if ((Number(e.ValorHasta) == 0) || (Number(importe) <= Number(e.ValorHasta))) {
                        output.porc = e.PorcentajeDescuento/100
                        output.tope = e.ValorTope
                    }
                } 
            }
            // unidades
            if (d.Tipo == 2) { 
                if (Number(e.ValorDesde) <= Number(cantidad)) {
                    if ((Number(e.ValorHasta) == 0) || (Number(cantidad) <= Number(e.ValorHasta))) {
                        output.porc = e.PorcentajeDescuento/100
                        output.tope = e.ValorTope
                    }
                } 
            }
        });  
        // console.log('<output>')
        // console.log(output)

        return output
     },

    onResize() {
        if (window.innerWidth > 600) 
        {
          this.mobileView=false;
        }
        else 
        {
          this.mobileView=true;
        }
      },

    btnEdit() {
      if (this.numPedidoEdit)
      {
        this.numPedidoEdit = false
      }
      else
      {
        this.numPedidoEdit = true
      }
    },


    validar() {
      var rex = new RegExp(/^\d+$/);
      var rex2 = new RegExp(/^[0-9]+([.,][0-9]+)?$/);
      var ok = true;

      this.$store.state.pedido.carrito.forEach((e)=> {

        if (e.permiteDecimales) { 
            if ((!rex2.test(e.cantidad)) || (!rex.test(e.porcentajeDescuento)))
            {
                ok = false;
                this.errorMsg = "Todos los campos cantidad y porcentaje deben contener valores numéricos mayores a 0" 
            }
            else {
                if (e.cantidad <= 0)
                {
                    ok = false;
                    this.errorMsg="Todos los campos cantidad deben contener valores mayores a 0" 
                }
            }
        }
        else {
            if (!rex.test(e.cantidad))
            {
                ok = false;
                this.errorMsg = "Todos los campos cantidad deben contener valores numéricos mayores a 0" 
            }
            else
            {
                var minVenta = 1
                if (e.unidadesMinimaVenta > 1)
                {
                    minVenta = e.unidadesMinimaVenta
                }
                if (e.cantidad < minVenta)
                {
                    ok = false;
                    this.errorMsg="Todos los campos cantidad deben contener valores iguales o superiores a las cantidades mínimas por producto" 
                }
                if (e.porcentajeDescuento > this.$store.state.user.usuario.PorcentajeDescuentoMaximoPrecio)
                {
                    ok = false;
                    this.errorMsg="Todos los campos porcentaje descuento deben contener valores iguales o menores al máximo descuento permitido" 
                }
                if (!this.$store.state.pedido.multiploValido)
                {
                    ok = false;
                    this.errorMsg="Todos los productos tienen que contener cantidades múltiplos de sus respectivas unidades de venta" 
                }
            }  
        }
      });
      return ok;
    },


    btnEliminarItem(id) {
      this.idItemEliminar = id
      var obj = {
                 txt:'¿Desea eliminar el item del presupuesto?',
                 txtBtnCancel:'Cancelar',
                 txtBtnOk:'Aceptar',
                 fCancel:null,
                 fOk:this.eliminarItem
                }
      this.$store.commit('popup/open',obj);
     },

    eliminarItem() {
      this.$store.commit('pedido/eliminarItemPedido',this.idItemEliminar)   
      if (this.$store.state.pedido.carrito.length > 0)
      {
        this.show = false;
        setTimeout(() => this.show = true, 50);
      }
      else
      {
        this.$router.push({ name: 'home' });
      }
    },

    btnEliminar() {
      var obj = {
                 txt:'¿Desea eliminar el presupuesto?',
                 txtBtnCancel:'Cancelar',
                 txtBtnOk:'Aceptar',
                 fCancel:null,
                 fOk:this.eliminarPedido
                }
      this.$store.commit('popup/open',obj);
    },


    eliminarPedido() {
      this.$store.commit('pedido/eliminarPedido')
      this.$router.push({ name: 'home' });
    },


     btnAgregar() {
       this.$router.push({ name: 'realizarPresupuestoCat' });
     },


     btnCerrarPopup() {
       this.showPopup = false; 
     },


     btnEnviar() {
       if (this.validar())
       {
         this.descuentosSend=[];
         this.descuentosAplicados.forEach((e)=> { 
           var ds = { DescuentoId: e.DescuentoId,
                     DescuentoPorcentaje:e. Porcentaje,
                     DescuentoImporte:e.importe
                   }
           this.descuentosSend.push(ds)
         });
         this.showPopup = true; 
       }
       else
       {
         var obj = {
                     txt:this.errorMsg,
                     txtBtnCancel:'',
                     txtBtnOk:'Aceptar',
                     fCancel:null,
                     fOk:null
                   }
         this.$store.commit('popup/open',obj);
       }
     },


    promocionSinImpuestoLista(id) {
        var promociones = this.$store.state.pedido.promociones
        var promocion = promociones.find(e => (e.Id == id ));
        var precio = 0
        if (promocion != null) {
            promocion.Productos.forEach((p)=> { 
                precio = precio + ( p.Precio * p.Cantidad)     
            }); 
        }
        return precio
    },

    promocionImpuesto(id) {
        var promociones = this.$store.state.pedido.promociones
        var promocion = promociones.find(e => (e.Id == id ));
        var impuesto = 0
        if (promocion != null) {
            promocion.Productos.forEach((p)=> { 
                impuesto = impuesto + ( p.PrecioPromo * p.Cantidad * p.PorcentajeImpuesto/100)     
            }); 
        }
        return impuesto
    },

    promocionSinImpuestoPromo(id) {
        var promociones = this.$store.state.pedido.promociones
        var promocion = promociones.find(e => (e.Id == id ));
        var precio = 0
        if (promocion != null) {
            promocion.Productos.forEach((p)=> { 
                precio = precio + ( p.PrecioPromo * p.Cantidad)      
            }); 
        }
        return precio
    },


    // ----------------------- ENVIAR PEDIDO --------------------------
    btnEnviarPopup() {
        if (this.envioValido()) {
            this.preparaPedido()
            this.enviaPedido()
        }
    },

    preparaPedido() {
        this.$store.commit('loader/start')
        this.pedidos = []
        this.carritoDes.forEach((item => {
            if (item.id > 0) {
                //-------------------------------------- Calculo descuentos por producto --------------------------------
                var descPorProd = []
                this.descAsocs.forEach((d)=> { 
                    if ((d.IdProd == item.id) && (d.Desc > 0)) {
                        var descProd = { 
                            'DescuentoId': d.Id,
                            'DescuentoImporte': d.Desc,
                            'DescuentoPorcentaje': d.Porc*100
                        }
                        descPorProd.push(descProd)
                    }
                })
                //---------------------------------------------------------------------------------------------------------
                var producto = {'ProductoId':item.id,
                    'PromocionId':item.promocionId,
                    'Largo':0,
                    'Ancho':0,
                    'Cantidad':item.cantidad,
                    'PrecioLista':item.precioLista,
                    'Precio':item.precio-(item.precio*(item.porcentajeDescuento/100)),
                    'Descuento':item.precio*(item.porcentajeDescuento/100),
                    'Descuentos':item.arrayDescuentosProducto,
                    'Descuentosv2': descPorProd    
               } 
            }
            else if (item.promocionId > 0) {
                var producto = {'ProductoId':item.id,
                    'PromocionId':item.promocionId,
                    'Largo':0,
                    'Ancho':0,
                    'Cantidad':item.cantidad,
                    'PrecioLista':this.promocionSinImpuestoLista(item.promocionId),
                    'Precio':this.promocionSinImpuestoPromo(item.promocionId)-(this.promocionSinImpuestoPromo(item.promocionId)*(item.porcentajeDescuento/100)),
                    'Descuento':item.precio*(item.porcentajeDescuento/100),
                    'Descuentos':item.arrayDescuentosProducto,
                    'Descuentosv2': []      
                }
            }
            this.productos.push(producto)  
        }));

        var fechaEnt = ''
        if (this.$store.state.user.usuario.IngresaFechaEntrega) {
          var f = new Date(Date.parse(this.calendario))
          var mes = parseInt(f.getMonth()) + parseInt(1)
          fechaEnt = f.getDate()+"/"+mes+"/"+f.getFullYear()
        }

        //--------------------------------------- Agrupacion de descuentos ----------------------------------------------
        var descPedido = []
        this.descAsocAgrup.forEach((d) => {
            if (d.Desc > 0) {
                var dp = {
                    'DescuentoId': d.Id,
                    'DescuentoImporte': d.Desc,
                    'DescuentoPorcentaje': d.Porc
                }  
                descPedido.push(dp)
            }
        })
        //---------------------------------------------------------------------------------------------------------------

        this.pedido = {
          'Id': 1,
          'BorradorId': 0,
          'Fecha': this.getFechaActual(),      
          'FechaEntrega': fechaEnt,
          'FechaTarea': "01/01/2000",
          'ClienteId': this.$store.state.user.cliente.Id,
          'ClienteSucursalLinea': this.sucursal.Linea, 
          'ListaPrecioId': this.$store.state.user.cliente.ListaPrecioId,                                 
          'CondicionVentaId': this.condicionVenta.Id,
          "DepositoId": this.$store.state.user.cliente.DepositoId,
          "DescuentoComercialPorcentaje": this.$store.state.user.cliente.DescuentoPorcentaje,
          "DescuentoComercialImporte": this.subtotal * this.descAC,
          'Observaciones': this.observaciones,
          'CodigoHash': Math.floor(Math.random() * 1000000000),
          'Latitud': 0,
          'Longitud': 0,
          'Email': this.email,
          'GpsEncendido': false,
          'Productos': this.productos,
          'Descuentos': this.arrayDescuentosPedido,
          'Descuentosv2': descPedido      
        } 
        this.pedidos.push(this.pedido); 

        // console.log("<<<Pedido>>>")
        // console.log(this.pedidos)
        // console.log(JSON.stringify(this.pedidos))
    },


    enviaPedido() {
        axios.post('/WebSalesPresupuesto', {"Presupuestos":this.pedidos} ,{
            headers:{
                Token:        this.$store.state.user.usuario.Token,
                ClientSecret: this.$store.state.entorno.clientSecret,
                EmpresaId:    this.$store.state.entorno.idEmpresa
            }
        })
        .then((response) => {
            this.showPopup = false;
            this.$store.commit('loader/stop')
            // console.log(response.data)
            if (response.data.Code == 0) {
                if ((response.data.Pedidos != null)&&(response.data.Pedidos[0] != null)&&(response.data.Pedidos[0].Estado != -1)) {
                    if (this.$store.state.pedido.borradorId != 0) {
                        this.eliminarBorrador(this.$store.state.pedido.borradorId)
                    }
                    else {
                        if (this.$store.state.pedido.idPresupuestoConvertido != -1) {
                            this.updateEstadoPresupuesto()
                        }
                    else {
                        this.$store.commit('pedido/eliminarPedido');
                        this.$router.push({name: 'estadoPresupuesto'});
                    }
                }
            }
            else {
                var obj = {
                           txt:response.data.Pedidos[0].Mensaje,
                           txtBtnCancel:'',
                           txtBtnOk:'Aceptar',
                           fCancel:null,
                           fOk:null
                }
                this.$store.commit('popup/open',obj);
              }
            }
            else if (response.data.Code == 99) {
                alert(response.data.Message) 
                this.$router.push({name: 'login'});
            }
            else {
                alert(response.data.Message);  
            }
        })
        .catch((error) => {
            alert(error);  
        });
    },


    // ----------------------- GUARDAR PEDIDO --------------------------
    btnGuardar() {
        this.preparaPedido() 
        this.guardaPedido() 
    },


    guardaPedido() {
       axios.post('/WebSalesBorrador', this.pedido ,{
            headers:{
                Token:        this.$store.state.user.usuario.Token,
                ClientSecret: this.$store.state.entorno.clientSecret,
                EmpresaId:    this.$store.state.entorno.idEmpresa
            }
        })
        .then((response) => {
            this.$store.commit('loader/stop')
            if (response.data.Code == 0) {
                this.$store.commit('pedido/eliminarPedido');
                this.$router.push({name: 'estadoPedido'});
            }
            else if (response.data.Code == 99) {
                alert(response.data.Message) 
                this.$router.push({name: 'login'});
            }
            else {
                alert(response.data.Message);  
            }
        })
        .catch((error) => {
            alert(error) 
        });
    },



    eliminarBorrador (borradorId) {
      this.$store.commit('loader/start')
      var bdParam = { BorradorId:borradorId,
                      ClienteId:this.$store.state.user.cliente.Id,	
                      EmpleadoId:this.$store.state.user.usuario.EmpleadoId
                    }
  
      axios.put('/WebSalesBorrador',bdParam,{
      headers:{
                  Token:        this.$store.state.user.usuario.Token,
                  ClientSecret: this.$store.state.entorno.clientSecret,
                  EmpresaId:    this.$store.state.entorno.idEmpresa
              }
      }
      ).then((response) => {
        this.$store.commit('loader/stop')
        this.$store.commit('pedido/eliminarPedido');
        if (response.data.Code == 0)
         {
           if (this.$store.state.pedido.idPresupuestoConvertido != -1) {
             this.updateEstadoPresupuesto()
            }
            else {
             this.$router.push({name: 'estadoPedido'});
           }
         }
         else if (response.data.Code == 99)
         {
           alert(response.data.Message);
         }
         else
         {
        //    console.log(">>>>"+response.data.Message);
         }
      },(error) => { console.log(error) 
            alert(error);  })
    
    },

  
    updateEstadoPresupuesto() {
        this.$store.commit('loader/start')
        var params = { PresupuestosId:[this.$store.state.pedido.idPresupuestoConvertido] }
        axios.put('/WebSalesPresupuesto',params,{
            headers:{
                Token:        this.$store.state.user.usuario.Token,
                ClientSecret: this.$store.state.entorno.clientSecret,
                EmpresaId:    this.$store.state.entorno.idEmpresa
            }
        }).then((response) => {
            this.$store.commit('loader/stop')
            this.$store.commit('pedido/saveIdPresupuestoConvertido',-1);  
            this.$store.commit('pedido/eliminarPedido');
            this.$router.push({name: 'estadoPedido'});

        },
        (error) => { 
            this.$store.commit('loader/stop')
            this.$store.commit('pedido/saveIdPresupuestoConvertido',-1);  
            this.$store.commit('pedido/eliminarPedido');
            this.$router.push({name: 'estadoPedido'});
            alert(error)
        })

    },

    envioValido() {

      var valido = true  
      var msg = '' 

      if ((this.showCondicionVenta)&&(this.condicionVenta==""))
      {
        valido = false    
        msg = 'Debe ingresar una condición de venta para poder continuar.' 
      }

      if ((this.showSucursal)&&(this.sucursal==""))
      {
        valido = false    
        msg = 'Debe ingresar una sucursal de entrega para poder continuar.' 
      }
      if ((this.showCalendar)&&(this.calendario==""))
      {
        valido = false    
        msg = 'Debe ingresar fecha de despacho para poder continuar.' 
      }

      if (!valido)  
      {
        var obj = {
                      txt: msg,
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
          this.$store.commit('popup/open',obj);
        }

        return valido
     },


     getFechaActual(){
        //'Fecha': "dd/mm/yyyy hh:mm",      
        var date    = new Date();
        var dateUTC = new Date();    
        var dia     =  ''
        var mes     =  ''
        var hora    =  ''
        var minuto  =  ''

        dateUTC.setTime(date.getTime() + 10800000) 

        if (dateUTC.getDate()<10)
        {
          dia = '0'+ dateUTC.getDate().toString()
        }
        else
        {
          dia = dateUTC.getDate().toString()
        }

        if ((dateUTC.getMonth() + 1)<10)
        {
          mes = '0'+ (dateUTC.getMonth()+1).toString()
        }
        else
        {
          mes = (dateUTC.getMonth()+1).toString()
        }

        if (dateUTC.getHours()<10)
        {
          hora = '0'+ dateUTC.getHours().toString()
        }
        else
        {
          hora = dateUTC.getHours().toString()
        }

        if (dateUTC.getMinutes()<10)
        {
          minuto = '0'+ dateUTC.getMinutes().toString()
        }
        else
        {
          minuto = dateUTC.getMinutes().toString()
        }

        return  dia+'/'+mes+'/'+dateUTC.getFullYear()+' '+hora+':'+minuto;
     },


     getFechaActual2(){
      
       //'Fecha': "dd/mm/yyyy",      
        var date    = new Date();
        var dateUTC = new Date();    
        var dia     =  ''
        var mes     =  ''

        dateUTC.setTime(date.getTime() + 10800000) 

        if (dateUTC.getDate()<10)
        {
          dia = '0'+ dateUTC.getDate().toString()
        }
        else
        {
          dia = dateUTC.getDate().toString()
        }

        if ((dateUTC.getMonth() + 1)<10)
        {
          mes = '0'+ (dateUTC.getMonth()+1).toString()
        }
        else
        {
          mes = (dateUTC.getMonth()+1).toString()
        }

        return  dia+'/'+mes+'/'+dateUTC.getFullYear();
     },


     setCalendar() {
       var date  = new Date();
       var currentMillis = date.getTime()
       var Dias =  [1,2,3,4,5,6,7]    
       var DiasNoLaborables = []
       var DiasNoLaborables2 = []
       var DiasHabiles =  this.$store.state.user.usuario.DiasEntregaHabiles

       // carga array dias habiles
       Dias.forEach((j) =>
       {
         if (!DiasHabiles.includes(j))
         {
           DiasNoLaborables.push(j-1) // modifica numeracion dias para hacerlo compatible con backend
         }
       });   

       var disables = {
          to:    new Date(date.getFullYear(),date.getMonth(),date.getDate()),
          days:  DiasNoLaborables,
          // dates: FeriadosDate
         }

       this.disabledDates = disables
     }

   },

   mounted () {
    if (this.$store.state.user.cliente.Email.length > 1) {
      this.email=this.$store.state.user.cliente.Email
    }
    else if (!this.$store.state.user.usuario.EsEmpleado)  {
      this.email=this.$store.state.user.email
    }   
    this.$store.commit('loader/stop')
    this.onResize()
    this.setCalendar()
   },

   created() {
     window.addEventListener('resize', this.onResize)
   },

   beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
   }

 }

</script>

<style scoped>


#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60);
}



#popup-envio-pedido{
  position: absolute;
  top: 50%;
  left: 50%; 
  transform: translate(-50%,-50%);
  width: 400px;
  min-width: 300px;
  border-radius: 15px;
  box-sizing: border-box;
  background: #ffffff;
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
}



#popup-btnClose-container{
  display: flex;            
  flex-direction:row;  
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;  
  justify-content: flex-end; 
  background:  #ffffff
}


#popup-titulo{
 font-size: 26px;
 color: #5C666F;
 text-align: center;
}

.labels-forms{
 margin-left: 30px;
 font-size: 12px;
 color: #5C666F;
 text-align: left;
}


#obs
{
  resize: none;
  width: 325px;
  margin-left: 30px;
  padding: 10px;
  border-radius: 5px;  
  height:90px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  font-family: 'Rubik', sans-serif;
}


.wc{
  background-color: #ffffff;
  width: 340px;
  margin-bottom: 20px;
  margin-left: 30px;
  padding-left: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
  -ms-box-sizing:content-box;
  -moz-box-sizing:content-box;
  box-sizing:content-box;
  -webkit-box-sizing:content-box; 
}


.wc-mobile{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;    
  align-items: center; 
  background-color: #ffffff;
  width: 90%;
  margin-left: 5%;
  margin-bottom: 20px;
  padding-left: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
  -ms-box-sizing:content-box;
  -moz-box-sizing:content-box;
  box-sizing:content-box;
  -webkit-box-sizing:content-box; 
}





select :disabled {
  color:#dddddd;
}

#btnContainerPopup{
  height: 80px;
  display: flex;            
  flex-direction: row;  
  justify-content: center;  
  align-items: center;  
}


.botonPopup{
 height: 40px;
 font-size: 10px;
 font-weight: bold;
 margin-left: 10px;
 margin-right: 10px;
 border-radius: 20px;  
 border-style: solid;
 border:none; 
}



#btnclose{
  width: 100px;
  color: #4969B2;
  background: #ffffff; 
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
  height: 30px;
  font-size: 9px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
}

#btnsend{
  width: 100px;
  background: #44C7F4; 
  color: #ffffff;
  outline: none;
  height: 30px;
  font-size: 9px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
}


.boton:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }

.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}


/*----------------------------*/

 #subheader {
  width: 100%;
  height: 35vh;
  background: linear-gradient(#005A9F , #1899D6);
 }

 #main-container{
  position: absolute;
  top: 55vh;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 700px;
  height: 85vh;
 }

 #label-container{
  width: 700px;
  height: 10vh;
 }

  #label{
  color:#ffffff;
  font-size: 27px;
 }

  #container{
   width: 700px;
   height: 75vh;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   box-shadow: 3px 3px 4px #dddddd;
   background-color: #ffffff;
   display: flex;
   flex-direction:column; 
   align-items: center; 
  }


#header-pedido{
 width: 700px;
 height: 50px; 
 display: flex;      
 flex-direction: row;  
 justify-content: center; 
 align-items: center; 
}

#header-pedidoL{
 width: 230px;
 height: 100%; 
 display: flex;      
 flex-direction: row;  
 background: #ffffff;
 justify-content: flex-start;
 align-items: center;    
}

#header-pedidoR{
 width: 600px;
 height: 100%; 
 display: flex;      
 flex-direction: row;  
 background: #ffffff;
 justify-content: flex-start;  
 align-items: center;    
}


.nPedido{
 font-size: 18px;
 font-weight: bold;
 color:#5D6770;
}


 input{
 width: 80px; 
 font-size: 18px;
 text-align: center;
 color:#5D6770;
 border-radius: 5px;  
 height:20px;
 border:none; 
 border-style: solid;
 border-width: 1px;
 border: 1px solid #dddddd;
} 

.inputReadonly{
 width: 80px; 
 border:none; 
} 



#label-editar{
 font-size: 12px;
 color:#5D6770;
}


#total-container{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row; 
  justify-content: flex-end; 
  align-items: center; 
}



#list-container{
  width: 660px;
  height: 60vh;
  padding-top: 30px;
  background: #ffffff;
  overflow: auto;
  display: flex;
  flex-direction:column; 
  align-items: center; 
 }


#btnContainer{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row; 
  justify-content: flex-end; 
  align-items: center; 
}


.label-total{
 font-size: 16px;
 color:#5D6770;
}

.label-subtotal{
 font-size: 12px;
 color:#5D6770;
}
 

 .labels-forms{
 margin-left: 30px;
 font-size: 12px;
 color: #5C666F;
 text-align: left;
}



#btnEliminar{
  width: 100px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none; 
  /* color: #4969B2; */
  color: #ff0000;
  background: #ffffff; 
  border-radius: 20px;  
  border-width: 1px;
  border: 1px solid #ffffff;
  outline: none;
}



#btnGuardar{
  width: 100px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none; 
  color: #4969B2;
  background: #ffffff; 
  border-radius: 20px;  
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


#btnAgregar{
  width: 120px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none; 
  background: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}


.btnMobile{
  display: flex;
  flex-direction:row; 
  justify-content: center; 
  align-items: center;
  width: 60px;
  height: 25px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  background: #44C7F4; 
  border-color: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}


#btnEnviar{
  width: 80px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none; 
  background: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}


input[type="submit"]:hover
{
  cursor: pointer;
}

#icon:hover{cursor: pointer;}
#btnclose:hover{cursor: pointer;}
#btnsend:hover{cursor: pointer;}


 /* width */
  ::-webkit-scrollbar {
      width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd; 
      border-radius: 10px;
  }
  
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb; 
      border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc; 
  }
  
  
  ::-webkit-scrollbar { 
  display: block; }
 


</style>


// WEBPACK FOOTER //
// src/components/views/presupuestos/presupuesto.vue